var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common-footer" }, [
    _c(
      "div",
      { staticClass: "links" },
      [
        _c("policy-item", { attrs: { text: "在线客服" } }),
        _vm._v(" "),
        _c("span", { staticClass: "divider" }),
        _vm._v(" "),
        _c("policy-item", { attrs: { text: "用户协议" } }),
        _vm._v(" "),
        _c("span", { staticClass: "divider" }),
        _vm._v(" "),
        _c("policy-item", { attrs: { text: "隐私政策" } })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "copyright" }, [
      _c("p", [
        _c(
          "a",
          {
            attrs: { href: "javascript:void(0);" },
            on: { click: _vm.goUserinfo }
          },
          [_vm._v("Copyright © 2008-" + _vm._s(_vm.this_year))]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          { attrs: { href: "javascript:void(0);" }, on: { click: _vm.goHome } },
          [_vm._v("class.acagrid.com")]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          {
            attrs: { href: "javascript:void(0);" },
            on: { click: _vm.goMPLogs }
          },
          [
            _vm._v("2507181206"),
            _vm.is_prerelease ? [_vm._v("(PreRelease)")] : _vm._e()
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.is_temp_login
      ? _c(
          "div",
          { staticClass: "temp-user-logout" },
          [
            _c(
              "submit-button",
              { attrs: { plain: "" }, on: { click: _vm.logoutTempUser } },
              [_vm._v("登出代理账户")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-331f45a7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-331f45a7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/el-common-footer.vue
// module id = null
// module chunks = 